import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class NavButtons extends Component {
  static propTypes = {
    showNextButton: PropTypes.bool,
    backStepId: PropTypes.number,
    nextStepId: PropTypes.number,
    goToStep: PropTypes.func.isRequired
  };

  render () {
    const { showNextButton, goToStep, backStepId, nextStepId } = this.props;
    return (
      <div className='nav-buttons-wrapper'>
        { backStepId && (
          <button
            className='button button-edit'
            onClick={() => goToStep(backStepId)}
          >Back</button>
        )}
        { showNextButton && (
          <button
            className='button button-primary ml-auto'
            onClick={() => goToStep(nextStepId)}
          >Next</button>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/createJob/createJob/NavButtons.js